import React from 'react';
import { BrowserRouter as Router , Routes , Route } from 'react-router-dom'
import BlogTemplate from './componets/blogTemplate/BlogTemplate';
import HomePage from './componets/HomePage/HomePage';
import {ReadData} from './firebase Component/ReadData';
import LoadingPage from './loadingPage';
function App() {
  // const [blogs,setBlogs]=useState([]);
  const blogs =  ReadData("Blog")
  // useEffect(()=>{

    
  //   setBlogs(data)


    
    
  // },[data])
   

  
if(blogs){

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage blog={blogs}/>}></Route>
        {
          blogs.map((data)=>{
            return(
              <Route path={`/blog/${data.id}`} element={<BlogTemplate data={data}/>}></Route>
            )
          })
        }
        
      </Routes>
    </Router>
    
  )
  }
  else{
    return(
      <div class="stars">
        <div class="twinkling">
          <div class="clouds">
            <LoadingPage/>
          </div>
        </div>
      </div>
    )
  }
}
export default App;

// {/* <div className="align-middle App justify-center justify-items-center">


//   const MainPage = ( <div class="stars">
//   <div class="twinkling">
//   <div class="clouds">
// <HomePage/>
// <BlogSection/>

// </div>
// </div>
// </div>)





